/* eslint-disable react-hooks/exhaustive-deps */
import { VbzCheckbox } from '@smiles/voebiz-ui-kit';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useFilterData from '../../hooks/useFilterData';
import { CheckboxProps } from './types/types';
import { SyntheticEvent } from '../../types/event.type';

const Checkbox = ({ engaged, setContractedPlanValue, setUncheckBoxContracted }: CheckboxProps) => {
  const { t } = useTranslation('modalFilter');
  const plans = t('plans', { returnObjects: true }) as Array<string>;
  const { allStatesCheckEngaged } = useFilterData();
  const [contractedPlans, setContractedPlans] = useState<string[]>([]);

  const handleCheckBoxContractedPlan = async (e: SyntheticEvent) => {
    if (!contractedPlans.includes(e.target.value) && e.target.checked === true) {
      setContractedPlans([...contractedPlans, e.target.value]);
    }
    if (e.target.checked === false) {
      const auxArray = [...contractedPlans];
      for (let indice = 0; indice < contractedPlans.length; indice += 1) {
        if (contractedPlans[indice] + 1 === e.target.id) {
          auxArray.splice(indice, 1);
          setContractedPlans(auxArray);
          setUncheckBoxContracted ? setUncheckBoxContracted(true) : '';
        }
      }
    }
  };

  useEffect(() => {
    if (setContractedPlanValue) setContractedPlanValue(contractedPlans);
  }, [contractedPlans]);

  useEffect(() => {
    Object.entries(allStatesCheckEngaged).forEach((index: [string, boolean]) => {
      if (index[1] === true) {
        setContractedPlans((array: string[]) => [...array, index[0]]);
      }
    });
  }, []);

  return (
    <>
      {engaged && (
        <div className="modalcheckbox">
          {plans?.map((plan) => {
            return (
              <div className="checkboxhabilitado" key={plan}>
                <VbzCheckbox
                  id={plan + 1}
                  label={`Plano ${new Intl.NumberFormat().format(Number(plan))}`}
                  checked={contractedPlans.includes(plan)}
                  value={plan}
                  onChange={(e) => handleCheckBoxContractedPlan(e)}
                />
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default Checkbox;
